<template>
    <div>
        <div>
            <legend><strong>Hasil Penilaian Teknis</strong> </legend>
            <b-row>
                <div class="col-md-3">
                    <b-form-group label="Hasil Penilaian Teknis*">
                        <v-select id="default-select" v-model="dataPermohonan.hasil_vertek"
                            :options="['Setuju', 'Setuju dengan catatan', 'Ditolak','Penambahan KBLI']" disabled v-validate="'required'"
                            name="Hasil Verifikasi" :class="{ 'is-invalid': errors.has('form-1.Hasil Verifikasi') }" />
                        <span class="text-danger" v-if="errors.has('form-1.Hasil Verifikasi')">
                            {{ errors.first('form-1.Hasil Verifikasi') }}
                        </span>
                    </b-form-group>
                </div>
            </b-row>

            <legend><strong>Detail Izin Lokasi</strong></legend>

              <b-row>
                <b-col md="6">
                  <b-form-group label="Instansi Penerbit *" label-for="form">
                    <b-form-input disabled v-validate="'required'" name="Instansi Penerbit" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Instansi Penerbit'),
                    }" v-model="dataPermohonan.instansi_penerbit" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.Instansi Penerbit')">
                      {{ errors.first("form-1.Instansi Penerbit") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="File Izin Terbit *" label-for="username">
                     <b-button v-if="
                    dataPermohonan.file_izin_terbit != null &&
                    isValidUrl(dataPermohonan.file_izin_terbit)
                  " :href="dataPermohonan.file_izin_terbit" target="_blank"><i
                      class="glyphicon glyphicon-download text-white me-sm-1 mb-sm-2"></i>Download File Izin Terbit</b-button>
                  </b-form-group>

                 
                </b-col>

                <b-col md="6">
                  <b-form-group label="Nomor Izin Terbit *" label-for="form">
                    <b-form-input disabled v-validate="'required'" name="Nomor Izin Terbit" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Nomor Izin Terbit'),
                    }" v-model="dataPermohonan.nomor_izin_terbit" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.Nomor Izin Terbit')">
                      {{ errors.first("form-1.Nomor Izin Terbit") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Tanggal Izin Terbit *" label-for="form">
                    <input disabled type="date" v-validate="'required'" name="Tanggal Izin Terbit" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Tanggal Izin Terbit'),
                    }" v-model="dataPermohonan.tanggal_izin_terbit" />
                    <span class="text-danger" v-if="errors.has('form-1.Tanggal Izin Terbit')">
                      {{ errors.first("form-1.Tanggal Izin Terbit") }}
                    </span>
                  </b-form-group>
                </b-col>

              </b-row>

            <legend><strong>Tanda Tangan</strong></legend>
            <b-row>
                <div class="col-md-4">
                    <b-form-group label="Direktur">
                        <v-select disabled id="default-select" v-model="dataPermohonan.ttd_ba_vertek_1"
                            :reduce="user => user.id_user" label="nama_lengkap" :options="dataTtd" />
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group label="Ketua Tim">
                        <v-select disabled id="default-select" v-model="dataPermohonan.ttd_ba_vertek_2"
                            label="nama_lengkap" :reduce="user => user.id_user" :options="dataTtd" />
                    </b-form-group>
                </div>
                <!-- <div class="col-md-3">
                    <b-form-group label="Tanda Tangan 3">
                        <v-select disabled id="default-select" v-model="dataPermohonan.ttd_ba_vertek_3"
                            label="nama_lengkap" :reduce="user => user.id_user" :options="dataTtd" />
                    </b-form-group>
                </div> -->
                <div class="col-md-4">
                    <b-form-group label="Pimpinan Rapat">
                        <v-select disabled id="default-select" v-model="dataPermohonan.ttd_ba_vertek_4"
                            label="nama_lengkap" :reduce="user => user.id_user" :options="dataTtd" />
                    </b-form-group>
                </div>
                <!-- <div class="col-md-3">
                    <b-form-group label="Tanda Tangan 5">
                        <v-select disabled id="default-select" v-model="dataPermohonan.ttd_ba_vertek_5"
                            label="nama_lengkap" :reduce="user => user.id_user" :options="dataTtd" />
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group label="Pimpinan Rapat">
                        <v-select disabled id="default-select" v-model="dataPermohonan.pimpinan_rapat"
                            :reduce="user => user.value" label="text" :options="dataPimpinan" />
                    </b-form-group>
                </div> -->
            </b-row>

            <legend><strong>Koordinat</strong> </legend>
            <div class="row mb-md-2">
                <div class="col-sm-12 col-md-6">

                </div>
                <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                        <label class="d-inline-flex align-items-center">
                            <b-form-input v-model="filter" type="search" placeholder="Search..."
                                class="form-control form-control-sm ml-2"></b-form-input>
                        </label>
                    </div>
                </div>
            </div>
            <div class="table-responsive mb-0 datatables">
                <b-table striped hover :items="itemsWithNumber" :fields="fields" responsive="sm" :per-page="perPage"
                    :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter"
                    :filter-included-fields="filterOn" @filtered="onFiltered">
                    <template #cell(tanggal_pada_permohonan)="data">
                        {{ format_date(data.item.tanggal_pada_permohonan) }}
                    </template>
                </b-table>
            </div>
            <div class="row mb-md-2">
                <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                            <b-form-select class="form-control form-control-sm form-select form-select-sm"
                                v-model="perPage" size="sm" :options="pageOptions"></b-form-select>
                        </label>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">

                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination pagination-rounded mb-0">
                            <b-pagination first-text="First" prev-text="Prev" next-text="Next" last-text="Last"
                                v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                        </ul>
                    </div>
                </div>
            </div>
           
            <legend><strong>File Lampiran</strong></legend>
              <div class="row mb-3">
                <b-col md="6">
                  <b-form-group label="File Lampiran Peta " label-for="username">

                  </b-form-group>
                  <ul class="list-group" v-if="dataPermohonan.file_lampiran_ba.length != 0">
                    <li v-for="(file, index) in dataPermohonan.file_lampiran_ba" :key="index"
                      class="list-group-item d-flex justify-content-between align-items-center">
                      <div>
                        <span>{{ file ? file.split('/').pop() : '' }}</span>
                      </div>
                      <div>
                      <a :href="file" class="btn btn-sm btn-primary" target="_blank"><i
                          class="glyphicon glyphicon-download text-white mb-sm-2"></i></a>
                      </div>
                      
                    </li>
                  </ul>
                  <template v-else>
                    <span class="text-danger">Tidak ada lampiran peta!</span>
                  </template>

                </b-col>
                <b-col md="6">
                  <b-form-group label="File Lampiran Tambahan " label-for="username">
                    
                  </b-form-group>

                  <b-button v-if="
                    dataPermohonan.file_lampiran_tambahan != null &&
                    isValidUrl(dataPermohonan.file_lampiran_tambahan)
                  " :href="dataPermohonan.file_lampiran_tambahan" target="_blank"><i
                      class="glyphicon glyphicon-download text-white me-sm-1 mb-sm-2"></i>Download File Lampiran
                    Tambahan</b-button>
                    <template v-else>
                    <span class="text-danger">Tidak ada lampiran tambahan!</span>
                  </template>
                </b-col>
              </div>
            <div class="row" v-if="dataPermohonan.hasil_vertek === 'Ditolak'">
                <b-col md="12">
                    <div class="form-group mt-2">
                        <b-form-group label="Alasan Penolakan:">
                            <ckeditor disabled :editor="wygEditor" v-model="dataPermohonan.alasan_penolakan"></ckeditor>
                        </b-form-group>
                    </div>
                </b-col>
            </div>
            <div class="row justify-content-between">
                <div class="col-4">
                    <div class="text-left">
                        <b-button @click="previousDokumen()" variant="primary"><i class="fa fa-caret-left" />
                            Previous</b-button>
                    </div>
                </div>
                <div class="col-4">
                    <div class="text-right">
                        <b-button @click="finishDokumen()" style="float:right" variant="success">Finish <i
                                class="fa fa-check" /></b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
export default {
    data() {
        return {
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "name",
            sortDesc: false,
            fields: [
                'no',
                { key: "nama_titik", sortable: true },
                { key: "bujur", sortable: true },
                { key: "lintang", sortable: true },
            ],
            dataPimpinan: [{
                value: 'ttd_ba_vertek_1', text: 'Penandatangan 1'
            }, {
                value: 'ttd_ba_vertek_2', text: 'Penandatangan 2',
            }, {
                value: 'ttd_ba_vertek_3', text: 'Penandatangan 3',
            }, {
                value: 'ttd_ba_vertek_4', text: 'Penandatangan 4',
            }, {
                value: 'ttd_ba_vertek_5', text: 'Penandatangan 5',
            }],
        }
    },
    components: { vSelect },
    props: {
        dataPermohonan: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataKlasifikasi: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataProvinsi: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataKabupaten: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataJenisPermohonan: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataKecamatan: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataTtd: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataKordinat: {
            type: Array,
            default: () => {
                return [];
            },
        },
        wygEditor: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    computed: {
        itemsWithNumber() {
            return this.dataKordinat.map((d, index) => ({ ...d, no: index + 1 }))
        },
        rows() {
            return this.dataKordinat.length;
        }
    },
    methods: {
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        finishDokumen() {
            this.$emit('finishDokumen')
        },

        previousDokumen() {
            this.$emit('previousDokumen')
        },

        getKabupaten(data) {
            this.$emit('getKabupaten', data)
        },

        getKecamatan(data) {
            this.$emit('getKecamatan', data)
        },
        isValidUrl(urlString) {
      var a = document.createElement("a");
      a.href = urlString;
      return a.host && a.host != window.location.host;
    },

    }
}
</script>